"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));
var _react = _interopRequireDefault(require("react"));
var _panameraReactUi = require("@olxid/panamera-react-ui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var css = {
  "kycWrapper": "ragnarok-3j5vt",
  "heading": "ragnarok-2ntUi",
  "content": "ragnarok-3A-sK",
  "helper": "ragnarok-3BXuT",
  "kycContinueToChat": "ragnarok-1enPZ",
  "iconKyc": "ragnarok-317lU"
};
var KycPopupConfig = function KycPopupConfig(_ref) {
  var kycPopupData = _ref.kycPopupData;
  return (0, _jsx2.default)("div", {
    className: css.kycWrapper
  }, void 0, (0, _jsx2.default)("div", {
    className: css.iconKyc
  }, void 0, kycPopupData.icon), (0, _jsx2.default)("div", {
    className: css.heading
  }, void 0, kycPopupData.heading), (0, _jsx2.default)("div", {
    className: css.content
  }, void 0, kycPopupData.detailText), kycPopupData.helperText && (0, _jsx2.default)("div", {
    className: css.helper
  }, void 0, kycPopupData.helperText), kycPopupData.cta && (0, _jsx2.default)(_panameraReactUi.Button, {
    type: kycPopupData.cta.type,
    fixed: true,
    onClick: kycPopupData.cta.handler,
    "data-aut-id": kycPopupData.cta.id,
    className: css[kycPopupData.cta.css]
  }, void 0, kycPopupData.cta.text));
};
var _default = exports.default = KycPopupConfig;
KycPopupConfig.propTypes = {
  kycPopupData: _propTypes.default.object
};
KycPopupConfig.defaultProps = {
  kycPopupData: {}
};